import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-waypoints',
	templateUrl:'./WayPointsPluginPage.html',
	styles: [],
	styleUrls:['./WayPointsPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WayPointsPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_680 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>waypoints</artifactId>
</dependency>
\`\`\``;
	mdContent_681 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:waypoints:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_682 = `\`\`\`json
"waypoints": "^4.0.1"
\`\`\``;
	mdContent_683 = `\`\`\`java
// No Java code needed — Waypoints JS is auto-registered.
// Use waypoints in your Angular/TypeScript code:
// var waypoint = new Waypoint({
//   element: document.getElementById('thing'),
//   handler: function(direction) { console.log('Scrolled to thing!'); }
// });
\`\`\``;
	mdContent_684 = `\`\`\`java
// Waypoints JS is auto-included via @TsDependency.
// Use in your Angular/JS code to trigger on scroll.
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
